import React, { useState } from 'react';
import Icon from '../components/Icon';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../config/api';
import { useNavigate } from 'react-router-dom';
import { toast } from '../components/ToastProvider';
import '../styles/Dashboard.css';
import '../styles/EditProfile.css';

const DAYS = ['Pon','Wt','Śr','Czw','Pt','Sob','Ndz'];
const HOURS = [];
for (let h = 6; h <= 22; h++) {
  HOURS.push(`${String(h).padStart(2,'0')}:00`);
  if (h < 22) HOURS.push(`${String(h).padStart(2,'0')}:30`);
}

const DEFAULT_SERVICES = [
  { id:1, name:'Strzyżenie damskie',   price:80,  duration:45 },
  { id:2, name:'Strzyżenie męskie',    price:50,  duration:30 },
  { id:3, name:'Koloryzacja',          price:150, duration:90 },
  { id:4, name:'Baleyage',             price:200, duration:120 },
  { id:5, name:'Strzyżenie brody',     price:40,  duration:20 },
  { id:6, name:'Keratyna',             price:250, duration:120 },
];

const EditProfile = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  const [tab, setTab] = useState('profile');

  const [form, setForm] = useState({
    firstName: user?.firstName || '',
    lastName:  user?.lastName  || '',
    phone:     user?.phone     || '',
    email:     user?.email     || '',
  });
  const [passwords, setPasswords] = useState({ current: '', new1: '', new2: '' });
  const [saving, setSaving] = useState(false);

  const salonDataKey = `hairkus_salon_profile_${user?.id}`;
  const loadSalonData = () => {
    const def = {
      bio: '',
      hours: { Pon:{from:'09:00',to:'18:00',open:true}, Wt:{from:'09:00',to:'18:00',open:true}, Śr:{from:'09:00',to:'18:00',open:true}, Czw:{from:'09:00',to:'18:00',open:true}, Pt:{from:'09:00',to:'18:00',open:true}, Sob:{from:'10:00',to:'15:00',open:true}, Ndz:{from:'10:00',to:'14:00',open:false} },
      services: DEFAULT_SERVICES,
      photos: [],
    };
    try { return { ...def, ...JSON.parse(localStorage.getItem(salonDataKey) || '{}') }; }
    catch { return def; }
  };
  const [salonData, setSalonData] = useState(loadSalonData);
  const [newService, setNewService] = useState({ name:'', price:'', duration:'' });
  const [salonSaving, setSalonSaving] = useState(false);

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSave = async (e) => {
    e.preventDefault();
    if (passwords.new1 || passwords.new2) {
      if (!passwords.current) { toast.error('Podaj aktualne hasło!'); return; }
      if (passwords.new1.length < 6) { toast.error('Nowe hasło musi mieć minimum 6 znaków!'); return; }
      if (passwords.new1 !== passwords.new2) { toast.error('Nowe hasła nie są identyczne!'); return; }
    }
    setSaving(true);
    try {
      const updateData = {
        firstName: form.firstName,
        lastName: form.lastName,
        phone: form.phone,
        email: form.email,
      };
      
      if (passwords.new1) {
        updateData.currentPassword = passwords.current;
        updateData.newPassword = passwords.new1;
      }
      
      const updated = await apiFetch(`/users/${user.id}`, {
        method: 'PATCH',
        body: JSON.stringify(updateData),
      });
      
      login({ ...user, ...updated });
      
      toast.success('Profil zaktualizowany!');
      setPasswords({ current:'', new1:'', new2:'' });
     
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (err) {
      toast.error(err.message || 'Błąd podczas zapisywania');
    } finally {
      setSaving(false);
    }
  };

  const handleSalonSave = async () => {
    setSalonSaving(true);
    try {
      localStorage.setItem(salonDataKey, JSON.stringify(salonData));
      toast.success('Profil salonu zapisany!');

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch {
      toast.error('Błąd podczas zapisywania profilu salonu');
    } finally {
      setSalonSaving(false);
    }
  };

  const setHours = (day, field, val) => setSalonData(s => ({ ...s, hours: { ...s.hours, [day]: { ...s.hours[day], [field]: val } } }));
  const toggleDay = (day) => setSalonData(s => ({ ...s, hours: { ...s.hours, [day]: { ...s.hours[day], open: !s.hours[day].open } } }));

  const addService = () => {
    if (!newService.name || !newService.price) { toast.error('Podaj nazwę i cenę'); return; }
    const svc = { id: Date.now(), name: newService.name, price: Number(newService.price), duration: Number(newService.duration) || 60 };
    setSalonData(s => ({ ...s, services: [...s.services, svc] }));
    setNewService({ name:'', price:'', duration:'' });
  };
  const removeService = (id) => setSalonData(s => ({ ...s, services: s.services.filter(x => x.id !== id) }));

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 2*1024*1024) { toast.error('Zdjęcie może mieć max 2MB'); return; }
    const reader = new FileReader();
    reader.onload = (ev) => {
      setSalonData(s => ({ ...s, photos: [...(s.photos||[]).slice(0,4), ev.target.result] }));
    };
    reader.readAsDataURL(file);
  };

  const dashPath = { client:'/dashboard/client', salon:'/dashboard/salon', admin:'/dashboard/admin', franchisee:'/dashboard/franchisee' }[user?.role] || '/';

  const isSalon = user?.role === 'salon';

  return (
    <div className="dashboard-container">
      <div className="dashboard-wrapper">
        <div className="dashboard-header">
          <h1>Edycja profilu</h1>
          <p>Zarządzaj swoimi danymi i ustawieniami</p>
        </div>

        {/* Zakładki */}
        <div className="admin-tabs" style={{marginBottom:'24px'}}>
          <button className={`admin-tab ${tab==='profile'?'active':''}`} onClick={() => setTab('profile')}>
            <Icon name="user" style={{marginRight:'7px'}} />Dane osobowe
          </button>
          {isSalon && (
            <>
              <button className={`admin-tab ${tab==='hours'?'active':''}`} onClick={() => setTab('hours')}>
                <Icon name="clock" style={{marginRight:'7px'}} />Godziny otwarcia
              </button>
              <button className={`admin-tab ${tab==='services'?'active':''}`} onClick={() => setTab('services')}>
                <Icon name="service" style={{marginRight:'7px'}} />Usługi
              </button>
              <button className={`admin-tab ${tab==='photos'?'active':''}`} onClick={() => setTab('photos')}>
                <Icon name="image" style={{marginRight:'7px'}} />Zdjęcia
              </button>
            </>
          )}
        </div>

        {/* Profil */}
        {tab === 'profile' && (
          <div className="profile-edit-grid">
            <div className="profile-avatar-card">
              <div className="profile-avatar-big">{(user?.firstName?.[0]||'?')}{(user?.lastName?.[0]||'')}</div>
              <h3>{user?.firstName} {user?.lastName}</h3>
              <span className="role-chip">{{ client:' Klient', salon:' Salon', admin:' Admin', franchisee:' Franczyzobiorca' }[user?.role]}</span>
              <p className="profile-email">{user?.email}</p>
              <button className="back-btn" onClick={() => navigate(dashPath)}>← Wróć do panelu</button>
            </div>
            <div className="profile-form-card">
              <form onSubmit={handleSave}>
                <div className="profile-section">
                  <h3>Dane osobowe</h3>
                  <div className="profile-form-grid">
                    <div className="profile-field"><label>Imię</label><input name="firstName" value={form.firstName} onChange={handleChange} required /></div>
                    <div className="profile-field"><label>Nazwisko</label><input name="lastName" value={form.lastName} onChange={handleChange} required /></div>
                    <div className="profile-field"><label>Email</label><input name="email" value={form.email} disabled className="disabled-field" /><small>Email nie może być zmieniony</small></div>
                    <div className="profile-field">
                      <label>Telefon</label>
                      <input 
                        name="phone" 
                        value={form.phone} 
                        onChange={(e) => {
                          let value = e.target.value;
                          let formatted = '';
                          
                          if (value.startsWith('+48')) {
                            let cleaned = value.substring(3).replace(/\D/g, '');
                            if (cleaned.length > 9) cleaned = cleaned.substring(0, 9);
                            
                            formatted = '+48 ';
                            if (cleaned.length > 6) {
                              formatted += cleaned.substring(0, 3) + ' ' + cleaned.substring(3, 6) + ' ' + cleaned.substring(6);
                            } else if (cleaned.length > 3) {
                              formatted += cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
                            } else {
                              formatted += cleaned;
                            }
                          } else {
                            let cleaned = value.replace(/\D/g, '');
                            if (cleaned.length > 9) cleaned = cleaned.substring(0, 9);
                            
                            formatted = cleaned;
                            if (cleaned.length > 6) {
                              formatted = cleaned.substring(0, 3) + ' ' + cleaned.substring(3, 6) + ' ' + cleaned.substring(6);
                            } else if (cleaned.length > 3) {
                              formatted = cleaned.substring(0, 3) + ' ' + cleaned.substring(3);
                            }
                          }
                          
                          setForm(prev => ({ ...prev, phone: formatted }));
                        }}
                        onFocus={(e) => {
                          if (!e.target.value || e.target.value.trim() === '') {
                            setForm(prev => ({ ...prev, phone: '+48 ' }));
                          }
                        }}
                        placeholder="+48 123 456 789" 
                      />
                    </div>
                  </div>
                </div>
                {isSalon && (
                  <div className="profile-section">
                    <h3>O salonie</h3>
                    <div className="profile-field" style={{gridColumn:'1/-1'}}>
                      <label>Krótki opis salonu</label>
                      <textarea rows={3} value={salonData.bio} onChange={e => setSalonData(s => ({...s, bio: e.target.value}))} placeholder="Opisz swój salon..." style={{width:'100%',padding:'12px',border:'1.5px solid #e5e7eb',borderRadius:'10px',fontFamily:'inherit',fontSize:'0.95em',resize:'vertical'}} />
                    </div>
                  </div>
                )}
                <div className="profile-section">
                  <h3>Zmiana hasła <span className="optional-label">(zostaw puste jeśli nie chcesz zmieniać)</span></h3>
                  <div className="profile-form-grid">
                    <div className="profile-field"><label>Aktualne hasło</label><input type="password" value={passwords.current} onChange={e => setPasswords(p=>({...p,current:e.target.value}))} placeholder="••••••••" /></div>
                    <div className="profile-field"><label>Nowe hasło</label><input type="password" value={passwords.new1} onChange={e => setPasswords(p=>({...p,new1:e.target.value}))} placeholder="min. 6 znaków" /></div>
                    <div className="profile-field"><label>Powtórz nowe hasło</label><input type="password" value={passwords.new2} onChange={e => setPasswords(p=>({...p,new2:e.target.value}))} placeholder="••••••••" /></div>
                  </div>
                </div>
                <div className="profile-actions">
                  <button type="button" className="profile-cancel-btn" onClick={() => navigate(dashPath)}>Anuluj</button>
                  <button type="submit" className="profile-save-btn" disabled={saving}>{saving ? 'Zapisywanie...' : 'Zapisz zmiany'}</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Godziny otwarcia */}
        {tab === 'hours' && isSalon && (
          <div className="dashboard-card-full">
            <div className="card-header-with-button">
              <h2><Icon name="clock" style={{marginRight:'8px'}} />Godziny otwarcia</h2>
              <button className="profile-save-btn" onClick={handleSalonSave} disabled={salonSaving}>
                {salonSaving ? 'Zapisywanie...' : 'Zapisz godziny'}
              </button>
            </div>
            <div className="hours-grid">
              {DAYS.map(day => {
                const h = salonData.hours[day] || { from:'09:00', to:'18:00', open:false };
                return (
                  <div key={day} className={`hours-day-card ${h.open ? 'open' : 'closed'}`}>
                    <div className="hours-day-header">
                      <span className="hours-day-name">{day}</span>
                      <label className="hours-toggle">
                        <input type="checkbox" checked={h.open} onChange={() => toggleDay(day)} />
                        <span className="hours-toggle-track" />
                        <span className="hours-toggle-label">{h.open ? 'Otwarte' : 'Zamknięte'}</span>
                      </label>
                    </div>
                    {h.open && (
                      <div className="hours-time-row">
                        <div className="hours-time-group">
                          <label>Otwarcie</label>
                          <select value={h.from} onChange={e => setHours(day,'from',e.target.value)} className="hours-select">
                            {HOURS.map(t => <option key={t}>{t}</option>)}
                          </select>
                        </div>
                        <span className="hours-sep">—</span>
                        <div className="hours-time-group">
                          <label>Zamknięcie</label>
                          <select value={h.to} onChange={e => setHours(day,'to',e.target.value)} className="hours-select">
                            {HOURS.filter(t => t > h.from).map(t => <option key={t}>{t}</option>)}
                          </select>
                        </div>
                      </div>
                    )}
                    {!h.open && <div className="hours-closed-label"><Icon name="close" color="#d1d5db" style={{marginRight:'6px'}} />Nieczynne</div>}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Usługi */}
        {tab === 'services' && isSalon && (
          <div className="dashboard-card-full">
            <div className="card-header-with-button">
              <h2><Icon name="service" style={{marginRight:'8px'}} />Usługi salonu</h2>
              <button className="profile-save-btn" onClick={handleSalonSave} disabled={salonSaving}>
                {salonSaving ? 'Zapisywanie...' : 'Zapisz zmiany'}
              </button>
            </div>
            <div className="services-list">
              {salonData.services.map(svc => (
                <div key={svc.id} className="service-item">
                  <div className="service-item-icon"><Icon name="scissors" color="#1e3c72" /></div>
                  <div className="service-item-info">
                    <strong>{svc.name}</strong>
                    <span><Icon name="clock" style={{marginRight:'5px',fontSize:'0.85em'}} />{svc.duration} min</span>
                  </div>
                  <div className="service-item-price">{svc.price} zł</div>
                  <button className="service-remove-btn" onClick={() => removeService(svc.id)}>
                    <Icon name="delete" color="#ef4444" />
                  </button>
                </div>
              ))}
            </div>
            <div className="service-add-form">
              <h4><Icon name="add" style={{marginRight:'7px'}} />Dodaj usługę</h4>
              <div className="service-add-grid">
                <div className="profile-field">
                  <label>Nazwa usługi *</label>
                  <input value={newService.name} onChange={e => setNewService(s=>({...s,name:e.target.value}))} placeholder="np. Strzyżenie damskie" />
                </div>
                <div className="profile-field">
                  <label>Cena (zł) *</label>
                  <input type="number" value={newService.price} onChange={e => setNewService(s=>({...s,price:e.target.value}))} placeholder="80" min="0" />
                </div>
                <div className="profile-field">
                  <label>Czas (min)</label>
                  <input type="number" value={newService.duration} onChange={e => setNewService(s=>({...s,duration:e.target.value}))} placeholder="45" min="5" />
                </div>
                <div style={{display:'flex',alignItems:'flex-end'}}>
                  <button className="profile-save-btn" onClick={addService} style={{width:'100%'}}>
                    <Icon name="add" style={{marginRight:'7px'}} />Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Zdjęcia */}
        {tab === 'photos' && isSalon && (
          <div className="dashboard-card-full">
            <div className="card-header-with-button">
              <h2><Icon name="image" style={{marginRight:'8px'}} />Zdjęcia salonu</h2>
              <button className="profile-save-btn" onClick={handleSalonSave} disabled={salonSaving}>
                {salonSaving ? 'Zapisywanie...' : 'Zapisz zmiany'}
              </button>
            </div>
            <div className="photos-grid">
              {(salonData.photos || []).map((src, i) => (
                <div key={i} className="photo-thumb">
                  <img src={src} alt={`Zdjęcie ${i+1}`} />
                  <button className="photo-remove-btn" onClick={() => setSalonData(s => ({...s, photos: s.photos.filter((_,j) => j !== i)}))}>
                    <Icon name="close" color="white" />
                  </button>
                </div>
              ))}
              {(salonData.photos||[]).length < 5 && (
                <label className="photo-upload-area">
                  <input type="file" accept="image/*" onChange={handlePhoto} style={{display:'none'}} />
                  <Icon name="add" color="#9ca3af" size="2x" />
                  <span>Dodaj zdjęcie</span>
                  <small>max 2MB, JPG/PNG</small>
                </label>
              )}
            </div>
            <p style={{color:'#9ca3af',fontSize:'0.85em',marginTop:'12px'}}>Możesz dodać maksymalnie 5 zdjęć salonu</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditProfile;
